import React from 'react';

import useScreenOrientation from './helpers/useScreenOrientation';
import GetBrowserInfo from './helpers/GetBrowserInfo';

import logoChrome from "../assets/chrome.png";
import logoLandscape from "../assets/svgs/Logo_Cliente+Proyecto.svg";
import logoPortrait from "../assets/svgs/Logo_Cliente+Proyecto_Portrait.svg";

import MenuAppBar from "./MenuAppBar"
import ItemCard from "./ItemCard"
import VideoPlayer from "./VideoPlayer"

import { ScenarioData } from "../data/scenario.data"

export default function Intro({ introViewVisible, setIntroViewVisible, videoViewVisible, setVideoViewVisible, productListViewVisible, setProductListViewVisible,
                                setScenario, setShowPortraitOptions, playBGM, setPlayBGM, setEnableBGM }: any) {

  const [isTerms, setIsTerms] = React.useState(false);
  const [scenarioList, setScenarioList] = React.useState<any>([]);
  const [transitionProductList, setTransitionProductList] = React.useState(false);
  const [transitionHideView, setTransitionHideView] = React.useState(false);

  const isLandscape = useScreenOrientation();
  const browserInfo = GetBrowserInfo();

  React.useEffect(() => {
    let scenarioData: any = ScenarioData()
    var scenario_list: any = [];
    for (let scenario of scenarioData) {
      if (scenario.active)
        scenario_list.push(scenario)
    }
    setScenarioList(scenario_list)
    setIsTerms(true)
  }, []);

  const handleTransitionToVideo = () => {    
    setVideoViewVisible(true) //activo video
    setEnableBGM(true) //habilita sonido
    setTimeout(() => {
      setIntroViewVisible(false)//desactivo primera vista, después de animación
    }, 1000);
  };

  const handleTransitionToProductList = () => {
    setProductListViewVisible(true) //activo segunda vista
    setTimeout(() => {
      setVideoViewVisible(false)//desactivo video
    }, 1000);
  };

  const setLocalScenario = (product: any) => {
    setTransitionHideView(true)
    setTransitionProductList(false)
    setTimeout(() => {
      setScenario(product)
    }, 900);
  };

  return (
    <div className="full-intro-container">
      {introViewVisible &&
        <div className={`intro-container`}>
          <div className={`intro-logo-container`}>
            <img className={`intro-logo ${isLandscape ? '' : 'portrait'} ${transitionProductList && !isLandscape ? 'transition-fade-out' : ''}`} src={isLandscape ? logoLandscape : logoPortrait} alt=''/>
          </div>
          {isTerms && <div className={`intro-terms ${isLandscape ? '' : 'portrait'} ${transitionProductList ? 'transition-fade-out' : ''}`}>
            Bienvenidos a nuestra plataforma 3D, en ella podrás experimentar el uso de nuestros productos en diferentes proyectos constructivos. Ten en cuenta que los colores, renders e imágenes presentados en esta plataforma son de carácter ilustrativo y pueden presentar modificaciones frente al producto físico. En caso de alguna inquietud, solicita la asesoría de nuestro equipo comercial y técnico.
          </div>
          }
          {browserInfo.isBrowserChrome === false && <div className={`intro-terms chrome ${isLandscape ? '' : 'portrait'} ${transitionProductList ? 'transition-fade-out' : ''}`}>
            Se recomienda usar el navegador Chrome <img className={`intro-terms-chromelogo ${isLandscape ? '' : 'portrait'}`} src={logoChrome} alt=''/>
          </div>
          }
          <div className={`intro-bottom ${isLandscape ? '' : 'portrait'} ${transitionProductList ? 'transition-fade-out' : ''}`} onClick={() => handleTransitionToVideo()} >Ingresar</div>
        </div>
      }

      {videoViewVisible && <VideoPlayer handleTransitionToProductList={handleTransitionToProductList}/>}

      {productListViewVisible &&
        <div className="full-item-card-scroller-container transition-fade-in">
          <MenuAppBar isLogoVisible={true} isPositionAbsolute={false} isBackButtonVisble={false} isBlur={false} setShowPortraitOptions={setShowPortraitOptions} playBGM={playBGM} setPlayBGM={setPlayBGM}/>
          <div className={`item-card-scroller-container ${transitionHideView ? 'transition-zoom-out' : ''}`}>
            <div className={`item-card-scroller-title ${isLandscape && browserInfo.isDeviceMobile === true ? 'mobile' : ''} ${isLandscape ? '' : 'portrait'} `}>
              ¿Cuál proyecto deseas explorar?
            </div>
            <div className="item-card-scroller transition-swipe-up">
              <div className="item-card-scroller-wrapper">
                {(scenarioList as {}[]).map((scenario: {}, index) =>
                  <div key={index} className={`item-card-wrapper ${isLandscape ? '' : 'portrait'}`}>
                    <ItemCard item={scenario} setItem={setLocalScenario} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}
